function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef, useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import ReactPlayer from 'react-player';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { validMediaFile } from "../../Metadata/helpers/validator";
















const propsToConfig = (props) => {
  const config = { url: '', options: { timelinks: {} } };

  let parsedProps = props.config.replace(/\(|\)/g, '').split(',');
  config.url = parsedProps.shift();

  parsedProps = (parsedProps.join(',') || '{}').replace(/&quot;/g, '"');

  try {
    parsedProps = JSON.parse(parsedProps);
  } catch (error) {
    parsedProps = {};
  }

  config.options = parsedProps;

  return config;
};

const formatTimeLinks = (timelinks) =>
Object.keys(timelinks).map((key) => {
  const timeLink = { timeHours: '00', timeMinutes: '00', timeSeconds: '00', label: '' };
  const splitTimes = key.split(':');
  if (splitTimes.length === 2) {
    [timeLink.timeMinutes, timeLink.timeSeconds] = splitTimes;
  } else {
    [timeLink.timeHours, timeLink.timeMinutes, timeLink.timeSeconds] = splitTimes;
  }
  timeLink.label = timelinks[key];
  return timeLink;
});

const MarkdownMedia = (props) => {
  const playerRef = useRef(null);

  const [newTimeline, setNewTimeline] = useState({
    timeHours: '00',
    timeMinutes: '00',
    timeSeconds: '00',
    label: ''
  });
  const [errorFlag, setErrorFlag] = useState(false);
  const { options } = propsToConfig(props);
  const originalTimelinks = formatTimeLinks((options === null || options === void 0 ? void 0 : options.timelinks) || {});
  const [playingTimelinkIndex, setPlayingTimelinkIndex] = useState(-1);
  const [isVideoPlaying, setVideoPlaying] = useState(false);
  const [temporalResource, setTemporalResource] = useState();
  const [mediaURL, setMediaURL] = useState('');
  const { control, register, getValues } = useForm({
    defaultValues: { timelines: originalTimelinks }
  });
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'timelines'
  });

  const validMediaUrlRegExp =
  /(^(blob:)?https?:\/\/(?:www\.)?)[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]$/;

  const seekTo = (seconds) => {var _playerRef$current;
    const playingStatus = isVideoPlaying;
    (_playerRef$current = playerRef.current) === null || _playerRef$current === void 0 ? void 0 : _playerRef$current.seekTo(seconds);
    setVideoPlaying(playingStatus);
  };

  const timeLinks = (_timelinks) => {
    const timelinks = _timelinks || {};
    return Object.keys(timelinks).map((timeKey, index) => {
      const linkIndex = index;
      const seconds = timeKey.
      split(':').
      reverse().
      reduce((_seconds, n, _index) => _seconds + parseInt(n, 10) * 60 ** _index, 0);

      let displayTime = timeKey;
      if (displayTime.split(':').length === 2) {
        displayTime = `00:${displayTime}`;
      }

      return /*#__PURE__*/(
        _jsx("div", { className: "timelink", title: timelinks[timeKey] }, timeKey + index.toString(), /*#__PURE__*/
        _jsx("b", {
          className: "timelink-icon",
          onClick: () => {
            seekTo(seconds);
            if (linkIndex === playingTimelinkIndex) {
              setVideoPlaying(false);
              setPlayingTimelinkIndex(-1);
            } else {
              setVideoPlaying(true);
              setPlayingTimelinkIndex(linkIndex);
            }
          } }, void 0, /*#__PURE__*/

        _jsx(Icon, { icon: linkIndex === playingTimelinkIndex ? 'pause' : 'play' })
        ), /*#__PURE__*/
        _jsx("div", {
          className: "timelink-time-label",
          onClick: () => {
            seekTo(seconds);
            setPlayingTimelinkIndex(linkIndex);
          } }, void 0, /*#__PURE__*/

        _jsx("b", {}, void 0, displayTime), /*#__PURE__*/
        _jsx("span", {}, void 0, timelinks[timeKey])
        )
        ));

    });
  };

  const updateParentForm = () => {
    if (props.onTimeLinkAdded) props.onTimeLinkAdded(getValues().timelines);
  };

  const appendTimelinkAndUpdateParent = (timelink) => {
    const currentTimelink = timelink || newTimeline;
    append(currentTimelink);
    updateParentForm();
  };

  const renderNewTimeLinkForm = () => /*#__PURE__*/
  _jsx("div", { className: "new-timelink" }, void 0, /*#__PURE__*/
  _jsx("div", { className: "timestamp" }, void 0, /*#__PURE__*/
  _jsx("input", {
    type: "text",
    onChange: (event) => {
      setNewTimeline(_objectSpread(_objectSpread({}, newTimeline), {}, { timeHours: event.target.value }));
    },
    className: "timestamp-hours",
    placeholder: "00",
    required: true,
    value: newTimeline.timeHours }
  ), /*#__PURE__*/
  _jsx("span", { className: "seperator" }, void 0, ":"), /*#__PURE__*/
  _jsx("input", {
    type: "text",
    onChange: (event) => {
      setNewTimeline(_objectSpread(_objectSpread({}, newTimeline), {}, { timeMinutes: event.target.value }));
    },
    className: "timestamp-minutes",
    placeholder: "00",
    required: true,
    value: newTimeline.timeMinutes }
  ), /*#__PURE__*/
  _jsx("span", { className: "seperator" }, void 0, ":"), /*#__PURE__*/
  _jsx("input", {
    type: "text",
    onChange: (event) => {
      setNewTimeline(_objectSpread(_objectSpread({}, newTimeline), {}, { timeSeconds: event.target.value }));
    },
    className: "timestamp-seconds",
    placeholder: "00",
    required: true,
    value: newTimeline.timeSeconds }
  )
  ), /*#__PURE__*/
  _jsx("input", {
    type: "text",
    onChange: (event) => {
      setNewTimeline(_objectSpread(_objectSpread({}, newTimeline), {}, { label: event.target.value }));
    },
    className: "timestamp-label",
    placeholder: "Enter title",
    value: newTimeline.label }
  ), /*#__PURE__*/
  _jsx("button", {
    type: "button",
    className: "new-timestamp-btn",
    onClick: () => {
      appendTimelinkAndUpdateParent(newTimeline);
      setNewTimeline({ timeHours: '00', timeMinutes: '00', timeSeconds: '00', label: '' });
    } }, void 0, /*#__PURE__*/

  _jsx(Icon, { icon: "plus" })
  )
  );


  const renderSingleTimeLinkInputs = (field, index) => /*#__PURE__*/
  _jsx("div", { className: "new-timelink" }, index, /*#__PURE__*/
  _jsx("div", { className: "timestamp" }, void 0, /*#__PURE__*/
  React.createElement("input", _extends({
    type: "text",
    className: "timestamp-hours",
    placeholder: "00",
    key: `${field.id}hours` },
  register(`timelines.${index}.timeHours`, {
    onChange: (_) => updateParentForm()
  }))
  ), /*#__PURE__*/
  _jsx("span", { className: "seperator" }, void 0, ":"), /*#__PURE__*/
  React.createElement("input", _extends({
    type: "text",
    className: "timestamp-minutes",
    placeholder: "00",
    key: `${field.id}minutes` },
  register(`timelines.${index}.timeMinutes`, {
    onChange: (_) => updateParentForm()
  }))
  ), /*#__PURE__*/
  _jsx("span", { className: "seperator" }, void 0, ":"), /*#__PURE__*/
  React.createElement("input", _extends({
    type: "text",
    className: "timestamp-seconds",
    placeholder: "00",
    key: `${field.id}seconds` },
  register(`timelines.${index}.timeSeconds`, {
    onChange: (_) => updateParentForm()
  }))
  )
  ), /*#__PURE__*/
  React.createElement("input", _extends({
    type: "text",
    className: "timestamp-label",
    placeholder: "Enter title",
    key: field.id },
  register(`timelines.${index}.label`, {
    onChange: (_) => updateParentForm()
  }))
  ), /*#__PURE__*/
  _jsx("button", {
    title: "Remove timelink",
    type: "button",
    className: "delete-timestamp-btn",
    onClick: () => {
      remove(index);
      updateParentForm();
    } }, void 0, /*#__PURE__*/

  _jsx(Icon, { icon: "trash-alt" })
  )
  );


  const renderTimeLinksForm = () => /*#__PURE__*/
  React.createElement(React.Fragment, null,
  fields.map((field, index) =>
  renderSingleTimeLinkInputs(field, index)
  ),
  renderNewTimeLinkForm()
  );


  const config = propsToConfig(props);
  useEffect(() => {
    if (config.url.startsWith('/api/files/')) {
      fetch(config.url).
      then(async (res) => {
        if (validMediaFile(res)) {
          return res.blob();
        }
        setErrorFlag(true);
        throw new Error('Invalid file');
      }).
      then((blob) => {
        setErrorFlag(false);
        setMediaURL(URL.createObjectURL(blob));
      }).
      catch((_e) => {});
    } else if (config.url.match(validMediaUrlRegExp)) {
      setMediaURL(config.url);
      setErrorFlag(false);
    } else {
      if (mediaURL && mediaURL.match(validMediaUrlRegExp) && temporalResource === undefined) {
        setTemporalResource(mediaURL);
      }
      setMediaURL(config.url);
    }
  }, [config.url]);

  useEffect(() => {
    if (
    temporalResource !== undefined &&
    ReactPlayer.canPlay(temporalResource) &&
    !mediaURL.match(validMediaUrlRegExp))
    {
      setErrorFlag(false);
      setMediaURL(temporalResource);
    }
  }, [temporalResource, mediaURL]);

  useEffect(() => () => {
    if (config.url.startsWith('/api/files/')) {
      setErrorFlag(false);
      URL.revokeObjectURL(mediaURL);
    }
  });

  const { compact, editing } = props;
  const dimensions = { width: '100%' };
  if (compact) {
    dimensions.height = '100%';
  }

  if (errorFlag) {
    return /*#__PURE__*/(
      _jsx("div", { className: "media-error" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This file type is not supported on media fields")
      ));

  }

  return /*#__PURE__*/(
    _jsx("div", { className: `video-container ${compact ? 'compact' : ''}` }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    React.createElement(ReactPlayer, _extends({
      className: "react-player",
      playing: isVideoPlaying,
      ref: playerRef,
      url: mediaURL },
    dimensions, {
      controls: true,
      onPause: () => {
        setVideoPlaying(false);
      },
      onPlay: () => {
        setVideoPlaying(true);
      },
      onError: (e) => {
        if (e.target.error.message.search(/MEDIA_ELEMENT_ERROR/) === -1) {
          setErrorFlag(true);
        }
      } })
    )
    ),

    !editing && /*#__PURE__*/_jsx("div", {}, void 0, timeLinks(config.options.timelinks)),
    editing && /*#__PURE__*/
    _jsx("div", { className: "timelinks-form" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "add-timelink",
      onClick: () => {var _playerRef$current2;
        const currentTime = (_playerRef$current2 = playerRef.current) === null || _playerRef$current2 === void 0 ? void 0 : _playerRef$current2.getCurrentTime();
        const hours = Math.floor(currentTime / 3600);
        const remainingSeconds = currentTime - hours * 3600;
        const minutes = Math.floor(remainingSeconds / 60);
        const seconds = Math.floor(remainingSeconds % 60);
        const timelink = {
          timeHours: hours < 10 ? `0${hours.toString()}` : hours.toString(),
          timeMinutes: minutes < 10 ? `0${minutes.toString()}` : minutes.toString(),
          timeSeconds: seconds < 10 ? `0${seconds.toString()}` : seconds.toString(),
          label: ''
        };
        appendTimelinkAndUpdateParent(timelink);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Add timelink")
    ), /*#__PURE__*/
    _jsx("h5", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Timelinks")
    ),
    renderTimeLinksForm()
    ), /*#__PURE__*/

    _jsx("p", { className: "print-view-alt" }, void 0, config.url)
    ));

};


export default MarkdownMedia;